import { IDocumentCardPreviewProps } from "@fluentui/react";

export interface IGraphGetUsersRequest {
	filter?: string;
	orderby: string;
	select: string; //Comma seperated values
}

export interface IGraphGetUsersResponse {
	id: string;
	displayName: string;
	mail: string;
	userPrincipalName: string;
	userType?: string;
}

export enum ShareableLinkRequestType {
	View = 'view',
	Edit = 'edit',
	BlocksDownload = 'blocksDownload'
}

export enum ShareableLinkRequestScope {
	Anonymous = "anonymous",
	Organization = "organization",
	Users = "users"
}

export interface IGraphCreateShareableLinkRequest {
	driveId: string;
	itemId: string;
	type: ShareableLinkRequestType;
	scope: ShareableLinkRequestScope;
	recipients?: string[]; //array of emails
	message?: string;
}

export interface IGraphGetDriveInfoFromSharepointIdRequest {
	driveId: string;
	sharepointId: string;
}

export interface IGraphSearchSharePointResponse {
	hits: any[];
	moreResultsAvailable: boolean;
	moreResulttotalsAvailable: number;
}

export enum InsightType {
	Recent = 'Recent',
	Shared = 'Shared',
	Trending = 'Trending'
}

export enum InsightContainerTypes {
	Site = 'site',
	OneDriveBusiness = 'onedrivebusiness',
	Mail = 'mail'
}

export interface IGraphInsightsItem {
	id: string;
	resourceReference?: IGraphInsightsResourceReference;
	resourceVisualization?: IGraphInsightsResourceVisualization;
	lastShared?: IGraphInsightsLastShared;
	lastUsed?: IGraphInsightsLastUsed;
	insightType: InsightType;
	imagePreview?: IDocumentCardPreviewProps;
	gridDate?: Date;
}
export interface IGraphInsightsResourceReference {
	id?: string;
	type?: string;
	webUrl?: string;
}

export interface IGraphInsightsResourceVisualization {
	containerDisplayName?: string;
	containerType?: string;
	containerWebUrl?: string;
	mediaType?: string;
	previewImageUrl?: string;
	previewText?: string;
	title?: string;
	type?: string;
	thumbnailPreviewUrl?: string;
}

export interface IGraphInsightsLastShared {
	id: string;
	resourceReference: IGraphInsightsResourceReference;
	resourceVisualization: IGraphInsightsResourceVisualization;
	sharedBy: IGraphInsightsLastSharedBy;
	sharedDateTime: string;
	sharingReference: IGraphInsightsLastSharedReference;
	sharingSubject: string;
	sharingType: string;
}

export interface IGraphInsightsLastSharedBy {
	address: string;
	displayName: IGraphInsightsResourceReference;
	id: IGraphInsightsResourceVisualization;
}

export interface IGraphInsightsLastSharedReference {
	id: string;
	type: IGraphInsightsResourceReference;
	webUrl: IGraphInsightsResourceVisualization;
}
export interface IGraphInsightsLastUsed {
	lastAccessedDateTime: string;
	lastModifiedDateTime: string;
}